import React from 'react';
import StudentAttendanceView from '../../components/Attendance/StudentAttendanceView';

export default function TeacherStudentAttendance() {
  return (
    <StudentAttendanceView
      mode="teacher"
      title="Student attendance"
      subtitle="Attendance for students in your active batches"
    />
  );
}
